import React from 'react'
import { NavLink } from 'react-router-dom'
import TeacherCard from './TeacherCard'
import { useTranslation } from 'react-i18next'

function TeacherReport() {
  const { t } = useTranslation();
  return (
    <>
    <div className="flex items-center xl:p-5 sm:p-0 justify-center">
      <div className="w-full border rounded-3xl shadow-xl p-5">

        <TeacherCard />
        <div className="flex flex-wrap md:justify-start justify-center space-x-5 border-b-2 text-base font-medium ">

          <NavLink to="../mentor-dash" className={({ isActive }) => (isActive ? "text-blue-500 border-b-2 border-blue-500" : undefined)}>{t("adminDash.findTeacher.dashboard")}</NavLink>

          <NavLink to=".././mentor-message" className={({ isActive }) => (isActive ? "text-blue-500 border-b-2 border-blue-500" : undefined)}>{t("adminDash.homeTutoring.viewProfile")}</NavLink>

          <NavLink to=".././online-sessions" className={({ isActive }) => (isActive ? "text-blue-500 border-b-2 border-blue-500" : undefined)}>{t("adminDash.homeTutoring.onlineTutoring")}</NavLink>

          <NavLink to=".././home-tutoring" className={({ isActive }) => (isActive ? "text-blue-500 border-b-2 border-blue-500" : undefined)}>{t("adminDash.homeTutoring.homeTutoring")}</NavLink>



          <NavLink to=".././mentor-chat" className={({ isActive }) => (isActive ? "text-blue-500 border-b-2 border-blue-500" : undefined)}>{t("adminDash.messages")}</NavLink>

          <NavLink to=".././teacher-report" className={({ isActive }) => (isActive ? "text-blue-500 border-b-2 border-blue-500" : undefined)}>{t("adminDash.teacherReport.report")}</NavLink>
        </div>
        <div>
          <h1>{t("adminDash.teacherReport.teacherReport")}</h1>
        </div>
      </div>
    </div>

  </>
  )
}

export default TeacherReport
